<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="syncService(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="success">mdi-database-sync</v-icon>
                </a>
              </template>
              <span>{{ $t("Sync") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <ConnectedServiceModal :ref="modalKey" @on-item-saved="onItemSaved" />
    <ConnectedServiceSyncModal :ref="syncModalKey" />
  </div>
</template>

<script>
import ConnectedServiceService from "@/services/ConnectedServiceService";
import ConnectedServiceModal from "@/components/administration/connectedService/ConnectedServiceModal.vue";
import ConnectedServiceSyncModal from "@/components/administration/connectedService/ConnectedServiceSyncModal.vue";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    ConnectedServiceModal,
    ConnectedServiceSyncModal,
  },

  data() {
    return {
      title: this.$t("ConnectedServices"),
      grid: {
        key: "connectedServicesGrid",
        dataSource: ConnectedServiceService.getGrid(),
        columns: [
          {
            field: "ServiceName",
            caption: this.$t("Service"),
            type: "string",
          },
          {
            field: "Description",
            caption: this.$t("Description"),
            type: "string",
          },
        ],
      },
      modalKey: "modalConnectedService",
      syncModalKey: "modalSyncConnectedService",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    syncModalInstance() {
      return this.$refs[this.syncModalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    syncService(dto) {
      this.syncModalInstance.edit(dto);
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          ConnectedServiceService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success(this.$t("ConnectedService") + " " + this.$t("DeletedSuccessfully"));
            }
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
  },
};
</script>